<template>
  <div class="template-details">
        <v-card>
            <v-card-actions class="shade ma-0 pa-0">
              <v-spacer></v-spacer>
              <v-btn small text color="blue" :disabled="!valid" class="text-capitalize" @click="apply()">
                Apply
              </v-btn>
              <v-btn small text color="blue" class="text-capitalize" @click="cancel()">
                Cancel
              </v-btn>
            </v-card-actions>
          <v-card-title>
            Template
          </v-card-title>

              <v-card-text>
                <v-form ref="form" v-model="valid">
                  <v-text-field
                    data-cy="name-text-field"
                    ref="template"
                    v-model="name"
                    :rules="[() => !!name || 'Name is required']"
                    label="Template"
                    class="ma-1"
                  >
                  </v-text-field>
                  <v-text-field
                    data-cy="desc-text-field"
                    ref="description"
                    v-model="description"
                    label="Description"
                    class="ma-1"
                  >
                  </v-text-field>
                  <v-autocomplete
                    data-cy="select-groups"
                    ref="categoryGroupList"
                    v-model="categoryGroupList"
                    :items="groups"
                    item-text="name"
                    item-value="id"
                    attach
                    chips
                    deletable-chips
                    hide-selected
                    multiple
                    label="Category Groups"
                  >
                 </v-autocomplete>
                  <v-autocomplete
                    data-cy="select-category"
                    ref="categoryList"
                    v-model="categoryList"
                    :items="items"
                    item-text="name"
                    item-value="id"
                    attach
                    chips
                    deletable-chips
                    hide-selected
                    multiple
                    label="Categories"
                  >
                 </v-autocomplete>

                </v-form>
              </v-card-text>
              <v-card-actions>
            <v-container>
              <v-row dense>
                <v-btn data-cy=submit-form color="primary" :disabled="!valid" text @click="apply">Submit</v-btn>
              </v-row>
            </v-container>
              </v-card-actions>

        </v-card>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { mdiDelete } from '@mdi/js'
import { clone } from 'lodash';

export default {
  name: 'TemplateDetails',
  components: {
  },
  data: () => {
    return {
      svgPath: mdiDelete,
      valid: false,
      formHasErrors: false,
      name: null,
      description: null,
      categoryList: null,
      categoryGroupList: null,
      id: null,
      numberRule: v  => {
        if (!v) return true;
        if (!isNaN(parseFloat(v)) && v >= 0 && v <= 999) return true;
        return 'Number has to be between 0 and 999';
      },
    }
  },
  beforeCreate() {},

  created() {
    this.$store.dispatch('getCategoryList');
    this.$store.dispatch('getCategoryGroupsList');
    if (this.template) {
      this.name = clone(this.template.name)
      this.description = clone(this.template.description)
      this.categoryList = clone(this.template.categoryList)
      this.categoryGroupList = clone(this.template.categoryGroupList)
      this.id = clone(this.template.id)
    }
  },

  mounted() {
   },

  beforeDestroy() {
  },

  computed: {
    ...mapGetters({
      template: 'getSelectedTemplate',
      items: 'getCategoryList',
      groups: 'getCategoryGroupsList',
    }),
  },

  methods: {
    cancel () {
      this.$router.push({name: 'Templates' })
    },
    apply () {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('applyTemplateDetails', {id: this.id, name: this.name, description: this.description, categoryList: this.categoryList, categoryGroupList: this.categoryGroupList});
        this.$router.push({name: 'Templates' })
      }
    }
  },

}
</script>

<style lang="scss" scoped>
.template-details {

}
</style>
